// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-enrollment-container {
  display: flex;
  flex-flow: column;
  align-content: center;
  background-color: var(--ods-color-white);
  border: 1px solid var(--ods-color-gray-20);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(44, 44, 84, 0.07);
  padding: 1.5rem;
  margin-bottom: 1.25rem;
}
.member-enrollment-container .member-enrollment-container__inner {
  display: flex;
  align-content: flex-start;
  width: 100%;
  align-items: center;
}
@media print {
  .member-enrollment-container .member-enrollment-container__inner {
    font-size: 0.75rem;
  }
}
.member-enrollment-container .member-enrollment-container__inner .member-enrollment-inner__header {
  display: flex;
  margin-left: 0.625rem;
  margin-right: 3.4375rem;
  font-weight: 700;
  font-size: 1.125rem;
}
.member-enrollment-container .member-enrollment-container__inner .census_doc_img {
  margin-left: 0.3125rem;
  width: 0.9375rem;
  height: 0.9375rem;
}
.member-enrollment-container .member-enrollment-container__inner .edit_enrollment_img {
  margin-top: 0.3125rem;
  margin-left: 0.3125rem;
  vertical-align: baseline;
  width: 0.9375rem;
  height: 0.9375rem;
}
.member-enrollment-container .member-enrollment-container__inner .field-name {
  font-weight: 700;
  padding-right: 0.625rem;
  display: flex;
  align-items: center;
  gap: 0.125rem;
}
.member-enrollment-container .member-enrollment-container__inner .member-enrollment-inner__row {
  display: flex;
  flex-flow: row;
  align-content: flex-end;
  align-items: center;
  margin-right: 2.8125rem;
  height: 2.9375rem;
  flex-grow: 1;
  flex-wrap: nowrap;
}
.member-enrollment-container .member-enrollment-container__inner .member-enrollment-inner__row .enrollment__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: nowrap;
}
.member-enrollment-container ods-tooltip ::ng-deep [slot=content] {
  font-weight: normal;
}

.members-info {
  width: 100%;
  font-size: 0.75rem;
}
.members-info tr {
  border-bottom: 1px solid var(--ods-color-gray-10);
}
.members-info td,
.members-info th {
  text-align: left;
  padding: 0.3125rem;
  padding-right: 1.25rem;
}

orchid-tooltip {
  margin-left: 1.25rem;
}

@media print {
  .no-print {
    display: none !important;
  }
  body {
    -webkit-print-color-adjust: exact;
  }
  ods-icon {
    display: none !important;
  }
  .census_doc_img,
  .edit_enrollment_img {
    display: none !important;
  }
  .member-enrollment-container {
    padding: 0.75rem !important;
    margin-bottom: 0.5rem !important;
  }
  .member-enrollment-inner__header {
    font-size: 11pt !important;
    margin-left: 0.25rem !important;
    margin-right: 1rem !important;
  }
  .member-enrollment-inner__row {
    height: auto !important;
    margin-right: 1rem !important;
    font-size: 10pt;
  }
  .field-name {
    font-size: 10pt !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/renewals/member-enrollment-panel/member-enrollment-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,wCAAA;EACA,0CAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACI;EANF;IAOI,kBAAA;EAEJ;AACF;AAAI;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAEN;AACI;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;AACN;AAEI;EACE,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;AAAN;AAGI;EACE,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AADN;AAII;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAFR;AASM;EACE,mBAAA;AAPR;;AAaA;EACE,WAAA;EACA,kBAAA;AAVF;AAYE;EACE,iDAAA;AAVJ;AAaE;;EAEE,gBAAA;EACA,kBAAA;EACA,sBAAA;AAXJ;;AAeA;EACE,oBAAA;AAZF;;AAeA;EACE;IACE,wBAAA;EAZF;EAeA;IACE,iCAAA;EAbF;EAgBA;IACE,wBAAA;EAdF;EAiBA;;IAEE,wBAAA;EAfF;EAkBA;IACE,2BAAA;IACA,gCAAA;EAhBF;EAmBA;IACE,0BAAA;IACA,+BAAA;IACA,6BAAA;EAjBF;EAoBA;IACE,uBAAA;IACA,6BAAA;IACA,eAAA;EAlBF;EAqBA;IACE,0BAAA;EAnBF;AACF","sourcesContent":[".member-enrollment-container {\n  display: flex;\n  flex-flow: column;\n  align-content: center;\n  background-color: var(--ods-color-white);\n  border: 1px solid var(--ods-color-gray-20);\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(44, 44, 84, 0.07);\n  padding: 1.5rem;\n  margin-bottom: 1.25rem;\n\n  .member-enrollment-container__inner {\n    display: flex;\n    align-content: flex-start;\n    width: 100%;\n    align-items: center;\n\n    @media print {\n      font-size: 0.75rem;\n    }\n\n    .member-enrollment-inner__header {\n      display: flex;\n      margin-left: 0.625rem;\n      margin-right: 3.4375rem;\n      font-weight: 700;\n      font-size: 1.125rem;\n    }\n\n    .census_doc_img {\n      margin-left: 0.3125rem;\n      width: 0.9375rem;\n      height: 0.9375rem;\n    }\n\n    .edit_enrollment_img {\n      margin-top: 0.3125rem;\n      margin-left: 0.3125rem;\n      vertical-align: baseline;\n      width: 0.9375rem;\n      height: 0.9375rem;\n    }\n\n    .field-name {\n      font-weight: 700;\n      padding-right: 0.625rem;\n      display: flex;\n      align-items: center;\n      gap: 0.125rem;\n    }\n\n    .member-enrollment-inner__row {\n      display: flex;\n      flex-flow: row;\n      align-content: flex-end;\n      align-items: center;\n      margin-right: 2.8125rem;\n      height: 2.9375rem;\n      flex-grow: 1;\n      flex-wrap: nowrap;\n\n      .enrollment__item {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        flex-wrap: nowrap;\n      }\n    }\n  }\n\n  ods-tooltip {\n    ::ng-deep {\n      [slot=\"content\"] {\n        font-weight: normal;\n      }\n    }\n  }\n}\n\n.members-info {\n  width: 100%;\n  font-size: 0.75rem;\n\n  tr {\n    border-bottom: 1px solid var(--ods-color-gray-10);\n  }\n\n  td,\n  th {\n    text-align: left;\n    padding: 0.3125rem;\n    padding-right: 1.25rem;\n  }\n}\n\norchid-tooltip {\n  margin-left: 1.25rem;\n}\n\n@media print {\n  .no-print {\n    display: none !important;\n  }\n\n  body {\n    -webkit-print-color-adjust: exact;\n  }\n\n  ods-icon {\n    display: none !important;\n  }\n\n  .census_doc_img,\n  .edit_enrollment_img {\n    display: none !important;\n  }\n\n  .member-enrollment-container {\n    padding: 0.75rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .member-enrollment-inner__header {\n    font-size: 11pt !important;\n    margin-left: 0.25rem !important;\n    margin-right: 1rem !important;\n  }\n\n  .member-enrollment-inner__row {\n    height: auto !important;\n    margin-right: 1rem !important;\n    font-size: 10pt;\n  }\n\n  .field-name {\n    font-size: 10pt !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
